<template>
  <div class="list">
    <NavBar></NavBar>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-empty v-if="list.length==0" description="暂无数据" />
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <van-card num="2" v-for="item in list" :key="item" tag="标签" price="2.00" desc="描述信息" :title="item.planTitle" thumb="https://img.yzcdn.cn/vant/ipad.jpeg" origin-price="10.00" />
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
export default {
  components: {

  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: {
        pageNum: 0,
        pageSize: 10
      }
    };
  },
  methods: {
    onLoad() {
      this.page.pageNum++;
      this.$postJson('/home/getPlanListRank', this.page).then((response) => {
        this.list.push.apply(this.list, response.list)
        console.log(this.list)
        //加载完以后结束
        if (response.list.length < this.page.pageSize) {
          this.finished = true;
          this.$notify('没有更多了');
        }
      })
    },
    onRefresh() {
      this.page.pageNum = 1;
      this.finished = false;
      this.$postJson('/home/getPlanListRank', this.page).then((response) => {
        this.list = response.list;
        this.refreshing = false;
      })
    }
  },
  created: function () {
  }
};
</script>
<style>
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  background-color: #39a9ed;
}
.list {
  margin-top: 46px;
}
</style>